export const CONTRACT_TYPE_LABELS = {
  SYMPOSION_HOTEL_OFFER: 'Symposion Hotel Angebotslegung',
  SYMPOSION_HOTEL_CONTRACT: 'Symposion Hotel Vertrag',
  PARTNER_HOTEL_CONTRACT: 'Partner Hotel Vertrag',
  FRIEND_HOTEL_CONTRACT: 'Friend Hotel Vertrag',
  FRIEND_LOCATION_CONTRACT: 'Friend Location Vertrag',
  CATALOG_REGISTRATION: 'Kataloganmeldung',
  NEWSLETTER: 'Newsletter',
  HOTEL_OF_THE_WEEK: 'Hotel der Woche',
  DIGITAL_SALES_BOOSTER: 'Digital Sales Booster',
  DIGITAL_SALES_BOOSTER_SETUP_FEE: 'Digital Sales Booster Set-Up Fee',
  SEM_BUSINESS: 'SEM Business',
  SEM_SETUP_FEE: 'SEM Set-Up Fee',
  SEM_SERVICE_FEE: 'SEM Servicegebühr',
  CATALOG_RIGHT_SIDE: 'Katalog rechte Seite',
  CATALOG_LOGO: 'Katalog Logo',
  CATALOG_TRANSLATION: 'Katalog Übersetzung',
  CATALOG_SECOND_CHANGE: 'Katalog 2. Änderung',
  CATALOG_QR: 'Katalog QR',
  MEETING_PACKAGE_IMPORT: 'Meeting Package Import',
  BASIC_AGREEMENT: 'Basic-Vereinbarung',
  POP_UP: 'Pop-Up',
  TEASER: 'Teaser',
};

export const INVOICE_INTERVAL_LABELS = {
  ONCE: 'Einmalig',
  M1: 'Monatlich',
  M3: 'Quartalsweise',
  M6: 'Halbjährlich',
  M12: 'Jährlich',
};

export const getContractTypeOptions = () => {
  return Object.entries(CONTRACT_TYPE_LABELS).map(([value, label]) => ({
    value,
    label
  }));
};

export const getInvoiceIntervalOptions = () => {
  return Object.entries(INVOICE_INTERVAL_LABELS).map(([value, label]) => ({
    value,
    label
  }));
};

export const formatContractType = (type: string): string => {
  return CONTRACT_TYPE_LABELS[type as keyof typeof CONTRACT_TYPE_LABELS] || type;
};

export const formatInvoiceInterval = (interval: string): string => {
  return INVOICE_INTERVAL_LABELS[interval as keyof typeof INVOICE_INTERVAL_LABELS] || interval;
};

export const centsToEuro = (cents: number): string => {
  const euros = cents / 100;
  return new Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency: 'EUR'
  }).format(euros);
};
